import _ from 'lodash';

import routes from '@configs/routes.json';
import languages from '@configs/languages.json';

import { get } from '@services/method';
import { ILocale } from '@models';

export const locales = (): Promise<ILocale[]> => {
  return get(routes.api.languages.get)
    .then((response) => response.json())
    .then((locales: string[]) =>
      locales.map((locale) => {
        let name = _.get(languages, `${locale}.name`);
        if (!name) {
          console.error(`no definition for locale: "${locale}"`);
          // just use the locale for the name if we are missing a definition
          name = locale;
        }
        return { locale, name };
      })
    );
};
